import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IGetPerfilQueryParams,
  IListaPaginada,
  IPerfil,
  IPostPerfilBody,
  IApiResponse,
  IPostPerfilResponseData,
  IPutPerfilBody,
  IPutPerfilResponseData,
  IDeletePerfilResponseData,
  IDeletePerfilPathParams
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {
  private readonly baseURL = '/Perfil';
  constructor(private httpClient: HttpClient) {}

  getPerfil(body: IGetPerfilQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IPerfil>>>(
      `${this.baseURL}/ObterPerfis`,
      body
    );
  }

  postPerfil(body: IPostPerfilBody) {
    return this.httpClient.post<IApiResponse<IPostPerfilResponseData>>(
      this.baseURL,
      body
    );
  }

  putPerfil(body: IPutPerfilBody) {
    return this.httpClient.put<IApiResponse<IPutPerfilResponseData>>(
      this.baseURL,
      body
    );
  }

  deletePerfil({ idUsuario, perfilId }: IDeletePerfilPathParams) {
    return this.httpClient.delete<IApiResponse<IDeletePerfilResponseData>>(
      `${this.baseURL}/${idUsuario}/${perfilId}`
    );
  }
}
